<div class="breakdown-container">
  <!-- Back Button -->
  <div class="breakdown-nav">
    <dx-button
      text="← Back to promotions"
      stylingMode="text"
      (onClick)="backRequested.emit()">
    </dx-button>
  </div>

  <!-- Promotion Header -->
  <div class="breakdown-title">{{ promotionName }}</div>

  <!-- Meta Row -->
  <div class="breakdown-meta">
    <span class="meta-item">{{ buyingGroup }}</span>
    <span class="type-badge" [ngClass]="getTypeClass(type)">{{ type }}</span>
    <span class="meta-item">Total volume: <strong>{{ formatNumber(totalVolume) }}</strong> cases</span>
  </div>

  <!-- Error State -->
  @if (loadFailed) {
    <div class="breakdown-empty">Failed to load product data. Please try again.</div>
  } @else if (!products || products.length === 0) {
    <div class="breakdown-empty">No product data available for this promotion.</div>
  } @else {
    <!-- Product Table -->
    <table class="breakdown-table">
      <thead>
        <tr>
          <th class="col-product">Product</th>
          <th class="col-volume">Volume (cases)</th>
          <th class="col-price">Promotion Price</th>
          <th class="col-price">Actual Price</th>
          <th class="col-pct">% of Promotion</th>
        </tr>
      </thead>
      <tbody>
        @for (item of products; track $index) {
          <tr>
            <td class="col-product">{{ item.product_name }}</td>
            <td class="col-volume numeric-cell">{{ formatNumber(item.volume) }}</td>
            <td class="col-price numeric-cell">{{ formatCurrency(item.promotion_price) }}</td>
            <td class="col-price numeric-cell">{{ formatCurrency(item.actual_price) }}</td>
            <td class="col-pct">
              @if (item.pct_of_promotion !== null) {
                <div class="pct-cell">
                  <span class="pct-label numeric-cell">{{ formatPercent(item.pct_of_promotion) }}</span>
                  <div class="pct-bar-track">
                    <div class="pct-bar-fill" [style.width.%]="item.pct_of_promotion"></div>
                  </div>
                </div>
              } @else {
                <span class="numeric-cell">—</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
